import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,[_c('div',{staticStyle:{"height":"100%"}},[_c('router-view'),_c('Loading'),_c('Notifications')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }